module.exports = __webpack_public_path__ + "static/img/active7.515c0bfa.png";